/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractRubricSummary } from './ContractRubricSummary';
import {
    ContractRubricSummaryFromJSON,
    ContractRubricSummaryFromJSONTyped,
    ContractRubricSummaryToJSON,
    ContractRubricSummaryToJSONTyped,
} from './ContractRubricSummary';

/**
 * 
 * @export
 * @interface ContractSummary
 */
export interface ContractSummary {
    /**
     * 
     */
    subtype: ContractSummarySubtypeEnum;
    /**
     * 
     */
    rubrics: Array<ContractRubricSummary>;
}


/**
 * @export
 */
export const ContractSummarySubtypeEnum = {
    Tiers: 'tiers',
    Categories: 'categories',
} as const;
export type ContractSummarySubtypeEnum = typeof ContractSummarySubtypeEnum[keyof typeof ContractSummarySubtypeEnum];


/**
 * Check if a given object implements the ContractSummary interface.
 */
export function instanceOfContractSummary(value: object): value is ContractSummary {
    if (!('subtype' in value) || value['subtype'] === undefined) return false;
    if (!('rubrics' in value) || value['rubrics'] === undefined) return false;
    return true;
}

export function ContractSummaryFromJSON(json: any): ContractSummary {
    return ContractSummaryFromJSONTyped(json, false);
}

export function ContractSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'subtype': json['subtype'],
        'rubrics': ((json['rubrics'] as Array<any>).map(ContractRubricSummaryFromJSON)),
    };
}

export function ContractSummaryToJSON(json: any): ContractSummary {
    return ContractSummaryToJSONTyped(json, false);
}

export function ContractSummaryToJSONTyped(value?: ContractSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subtype': value['subtype'],
        'rubrics': ((value['rubrics'] as Array<any>).map(ContractRubricSummaryToJSON)),
    };
}

